"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'customer';
exports.SET_SELECTED_CUSTOMER_PROFILE_ID = exports.namespace + "/SET_SELECTED_CUSTOMER_PROFILE_ID";
exports.GET_CUSTOMER_ACCOUNT = exports.namespace + "/GET_CUSTOMER_ACCOUNT";
exports.GET_CUSTOMER_PROFILE_BY_ID = exports.namespace + "/GET_CUSTOMER_PROFILE_BY_ID";
exports.CREATE_CUSTOMER_PROFILE = exports.namespace + "/CREATE_CUSTOMER_PROFILE";
exports.UPDATE_CUSTOMER_PROFILE = exports.namespace + "/UPDATE_CUSTOMER_PROFILE";
exports.DELETE_CUSTOMER_PROFILE = exports.namespace + "/DELETE_CUSTOMER_PROFILE";
exports.SET_SELECTED_PROFILE = exports.namespace + "/SET_SELECTED_PROFILE";
exports.SET_SINCE_EVENT_ID = exports.namespace + "/SET_SINCE_EVENT_ID";
exports.SET_PURCHASE_NOTIFICATION_BY_ID = exports.namespace + "/SET_PURCHASE_NOTIFICATION_BY_ID";
exports.REVERSE_PURCHASE_PPV = exports.namespace + "/REVERSE_PURCHASE";
exports.FETCH_USER_PURCHASES = exports.namespace + "/FETCH_USER_PURCHASES";
exports.PURCHASE_TVOD = exports.namespace + "/PURCHASE_TVOD";
exports.PURCHASE_PPV = exports.namespace + "/PURCHASE_PPV";
exports.CLEAR_PURCHASE_PPV = exports.namespace + "/CLEAR_PURCHASE_PPV";
exports.SET_PLAYER_SETTINGS = exports.namespace + "/SET_PLAYER_SETTINGS";
exports.CLEAR_PLAYER_SETTINGS = exports.namespace + "/CLEAR_PLAYER_SETTINGS";
exports.SET_TEXT_TRACK_STYLE = exports.namespace + "/SET_TEXT_TRACK_STYLE";
exports.SET_CUSTOMER_PACKAGES = exports.namespace + "/SET_CUSTOMER_PACKAGES";
//# sourceMappingURL=constants.js.map